import * as i0 from '@angular/core';
import { input, model, computed, Component } from '@angular/core';
import { NgStyle } from '@angular/common';
const _c0 = (a0, a1) => ({
  width: a0,
  height: a1
});
let NgxRadioButtonComponent = /*#__PURE__*/(() => {
  class NgxRadioButtonComponent {
    constructor() {
      // Inputs
      this.size = input(20);
      this.disabled = input(false);
      // Models
      this.checked = model(false);
      this.wrapperCLasses = computed(() => this.generateWrapperClasses());
    }
    handleCheck() {
      if (!this.disabled()) {
        this.checked.set(true);
      }
    }
    generateWrapperClasses() {
      const sizeClassMap = {
        16: ['border-6', 'border-300'],
        20: ['border-7', 'border-400'],
        24: ['border-8', 'border-500']
      };
      let colorClass;
      if (this.disabled()) {
        colorClass = this.checked() ? 'border-color-disabled' : 'border-color-air';
      } else {
        colorClass = this.checked() ? 'border-color-brand' : 'border-color-tint';
      }
      return `${colorClass} ${sizeClassMap[this.size()][this.checked() ? 0 : 1]}`;
    }
    static {
      this.ɵfac = function NgxRadioButtonComponent_Factory(t) {
        return new (t || NgxRadioButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxRadioButtonComponent,
        selectors: [["ngx-radio-button"]],
        inputs: {
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          disabled: [i0.ɵɵInputFlags.SignalBased, "disabled"],
          checked: [i0.ɵɵInputFlags.SignalBased, "checked"]
        },
        outputs: {
          checked: "checkedChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 6,
        consts: [[3, "click", "ngStyle"]],
        template: function NgxRadioButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function NgxRadioButtonComponent_Template_div_click_0_listener() {
              return ctx.handleCheck();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("ngx-radio-button radius-rounded cursor-pointer surface-elevated " + ctx.wrapperCLasses());
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(3, _c0, ctx.size() + "px", ctx.size() + "px"));
          }
        },
        dependencies: [NgStyle],
        styles: [".ngx-radio-button[_ngcontent-%COMP%]{box-sizing:border-box}.border-6[_ngcontent-%COMP%]{border:6px solid}.border-7[_ngcontent-%COMP%]{border:7px solid}.border-8[_ngcontent-%COMP%]{border:8px solid}"]
      });
    }
  }
  return NgxRadioButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-radio-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxRadioButtonComponent };
